/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon20Light = forwardRef('ArrowDCornerLeftDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 6a3 3 0 0 1 3-3h8.5a.5.5 0 0 1 0 1H10a2 2 0 0 0-2 2v10.793l4.646-4.647a.5.5 0 0 1 .708.708l-4.652 4.651a1.7 1.7 0 0 1-2.404 0l-4.652-4.651a.5.5 0 0 1 .708-.708L7 16.793V6Z" })));
});
